export const topPeopleMocked = [
  {
      "address": "0xc5f705ca8f70acc5f3d3db9636558102f528a475",
      "name": "alex-4135.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 1,
      "daoAmount": 49,
      "proposalsAmount": 0,
      "votesAmount": 3813,
      "participationScore": "480.21",
      "participationRelativeScore": 100
  },
  {
      "address": "0x88f659b4b6d5614b991c6404b34f821e10390ec0",
      "name": "jt603.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 2,
      "daoAmount": 93,
      "proposalsAmount": 0,
      "votesAmount": 3307,
      "participationScore": "415.83",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0xd03ad690ed8065edfdc1e08197a3ebc71535a7ff",
      "name": "daciv.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 3,
      "daoAmount": 133,
      "proposalsAmount": 0,
      "votesAmount": 2706,
      "participationScore": "331.56",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0xf4b0556b9b6f53e00a1fdd2b0478ce841991d8fa",
      "name": "olimpio.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 4,
      "daoAmount": 32,
      "proposalsAmount": 33,
      "votesAmount": 825,
      "participationScore": "308.67",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x06c4865ab16c9c760622f19a313a2e637e2e66a2",
      "name": "AEvolve",
      "avatar": "https://ipfs.io/ipfs/Qmc7XEFBtaFnNLiU61L6uNt4m56S2kd1VhHRavAmjpf1hp",
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 5,
      "daoAmount": 75,
      "proposalsAmount": 0,
      "votesAmount": 2406,
      "participationScore": "300.17",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x2ea5e9e452f85f55be47504153f25740a5f3d78a",
      "name": "archer36159.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 6,
      "daoAmount": 97,
      "proposalsAmount": 4,
      "votesAmount": 2393,
      "participationScore": "293.15",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x09ad31043b0b939576d5206b064ca1807c4160fd",
      "name": "dumindu.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 7,
      "daoAmount": 55,
      "proposalsAmount": 0,
      "votesAmount": 2256,
      "participationScore": "287.98",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x019ed608dd806b80193942f2a960e7ac8abb2ee3",
      "name": "webvr.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 8,
      "daoAmount": 75,
      "proposalsAmount": 0,
      "votesAmount": 2210,
      "participationScore": "287.90",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0xfad69bd739c64cc8e3f1c3bb3b60fe4f160174cc",
      "name": "hvax.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 9,
      "daoAmount": 5,
      "proposalsAmount": 1070,
      "votesAmount": 16,
      "participationScore": "286.35",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0xd31a84c20bc430ad75e6a1903e7ddbee52211072",
      "name": "harusame.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 10,
      "daoAmount": 125,
      "proposalsAmount": 0,
      "votesAmount": 2252,
      "participationScore": "282.95",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0xc077c537727b07a6521332da75fa8966192f425d",
      "name": "0xhamed.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 11,
      "daoAmount": 69,
      "proposalsAmount": 0,
      "votesAmount": 2310,
      "participationScore": "279.94",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0xd9293636ee3aa663fc563adb0912b0705dafb62c",
      "name": "tlmlit.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 12,
      "daoAmount": 127,
      "proposalsAmount": 5,
      "votesAmount": 3875,
      "participationScore": "275.68",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x2dabd1c849b5adc1fb421e043ba53be6bb2aec62",
      "name": "0xbull0.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 13,
      "daoAmount": 49,
      "proposalsAmount": 0,
      "votesAmount": 2175,
      "participationScore": "274.83",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x015122a625b45f68e6d795c0ab99fc7107e4c3b9",
      "name": "gokbelen.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 14,
      "daoAmount": 84,
      "proposalsAmount": 0,
      "votesAmount": 2055,
      "participationScore": "268.10",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x3f5d2058971dfd0103e3bf5e423620b5a42db357",
      "name": "3people.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 15,
      "daoAmount": 72,
      "proposalsAmount": 2,
      "votesAmount": 2233,
      "participationScore": "265.34",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x8eef779818afa953b0652e45438423ebe089f55a",
      "name": "souluv7.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 16,
      "daoAmount": 110,
      "proposalsAmount": 19,
      "votesAmount": 2479,
      "participationScore": "259.06",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0xe44782afe398800d7190796018c4b865e32ff806",
      "name": "porya.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 17,
      "daoAmount": 45,
      "proposalsAmount": 0,
      "votesAmount": 1928,
      "participationScore": "255.89",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x53c40473dcdfd927c4201ccfe24e314a7d7c3584",
      "name": "dow.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 18,
      "daoAmount": 52,
      "proposalsAmount": 0,
      "votesAmount": 2024,
      "participationScore": "254.76",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x97432c12ea8c957c3ae2d59c9953cf8df9cbc5b0",
      "name": "universemoney.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 19,
      "daoAmount": 64,
      "proposalsAmount": 4,
      "votesAmount": 2185,
      "participationScore": "247.27",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x183bdb344a07ee3d27f07ac4799a56e4a2fe5439",
      "name": "omahs.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 20,
      "daoAmount": 95,
      "proposalsAmount": 2,
      "votesAmount": 1934,
      "participationScore": "241.40",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x70ddb5abf21202602b57f4860ee1262a594a0086",
      "name": "3668.ethscriptions.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 21,
      "daoAmount": 93,
      "proposalsAmount": 0,
      "votesAmount": 1857,
      "participationScore": "240.71",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x8200d84590eceb10c6471268930e2924f34e3d69",
      "name": "bentvote.eth",
      "avatar": null,
      "isSmartContract": null,
      "description": null,
      "aum": null,
      "rank": 22,
      "daoAmount": 2,
      "proposalsAmount": 716,
      "votesAmount": 610,
      "participationScore": "237.82",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x413a9c69df59288ef9a7ebe78a2033dd2f3e1af3",
      "name": "muzard.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 23,
      "daoAmount": 62,
      "proposalsAmount": 0,
      "votesAmount": 1993,
      "participationScore": "237.72",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x7b0befc5b043148cd7bd5cfeeef7bc63d28edec0",
      "name": "layer3xyz.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 24,
      "daoAmount": 6,
      "proposalsAmount": 0,
      "votesAmount": 230,
      "participationScore": "235.61",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x344b1e4ac175f16d3ba40a688ca928e3768e275a",
      "name": "866.ethscriptions.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 25,
      "daoAmount": 90,
      "proposalsAmount": 0,
      "votesAmount": 1800,
      "participationScore": "233.14",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x0ff9b6ab6ec58ceb6d5ae8a1690dd5a0959ad002",
      "name": "xinyubtc.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 26,
      "daoAmount": 83,
      "proposalsAmount": 0,
      "votesAmount": 1790,
      "participationScore": "232.98",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0xfec447014eb1b96279d7fef62ea3f8848f99d09d",
      "name": "nurik9210.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 27,
      "daoAmount": 38,
      "proposalsAmount": 0,
      "votesAmount": 1689,
      "participationScore": "231.88",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x707d306714ff28560f32bf9dae973bd33cd851c5",
      "name": "8848community.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 28,
      "daoAmount": 69,
      "proposalsAmount": 0,
      "votesAmount": 1765,
      "participationScore": "231.42",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x1b686ee8e31c5959d9f5bbd8122a58682788eead",
      "name": "delegate.l2beat.eth",
      "avatar": null,
      "isSmartContract": null,
      "description": null,
      "aum": null,
      "rank": 29,
      "daoAmount": 12,
      "proposalsAmount": 133,
      "votesAmount": 790,
      "participationScore": "227.61",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0xc0882631627786eea84a851f66cdd1c0a070ea28",
      "name": "filv85.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 30,
      "daoAmount": 60,
      "proposalsAmount": 0,
      "votesAmount": 2023,
      "participationScore": "226.74",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x0516cf37b67235e07af38ad8e388d0e68089b0f2",
      "name": "soseth.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 31,
      "daoAmount": 75,
      "proposalsAmount": 0,
      "votesAmount": 1703,
      "participationScore": "224.27",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x4d9ba778b7f121e58e5d3bb6aef514e035a7c7f5",
      "name": "sandyjindal.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 32,
      "daoAmount": 59,
      "proposalsAmount": 1,
      "votesAmount": 1523,
      "participationScore": "223.36",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x2d5823e8e8b4dfbf599a97566ff2a121cc141d60",
      "name": "orchidprotocol.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 33,
      "daoAmount": 73,
      "proposalsAmount": 0,
      "votesAmount": 1700,
      "participationScore": "222.71",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x1b5b4fcedf1252cd92496a2fd5c593b39ac49b01",
      "name": "scryfans.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 34,
      "daoAmount": 71,
      "proposalsAmount": 0,
      "votesAmount": 1700,
      "participationScore": "222.41",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x3dbadc86d19416ec16d81aa07ff2609e6241e7e9",
      "name": "xielaoban.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 35,
      "daoAmount": 67,
      "proposalsAmount": 0,
      "votesAmount": 1770,
      "participationScore": "221.72",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0xc97370f22ed5ac4c7b24a8e1ca9d81febb3b9457",
      "name": "daohuas.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 36,
      "daoAmount": 74,
      "proposalsAmount": 0,
      "votesAmount": 1707,
      "participationScore": "221.62",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0xc54a6c3778016b06cbd126ccc3b5bc06c5f666fb",
      "name": "62677.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 37,
      "daoAmount": 60,
      "proposalsAmount": 2,
      "votesAmount": 1767,
      "participationScore": "220.38",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x76ac6ad4e4e7c2e0b4ceeb30745bd53df3a85774",
      "name": "dextrysblockchain.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 38,
      "daoAmount": 68,
      "proposalsAmount": 0,
      "votesAmount": 1675,
      "participationScore": "219.63",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x070341aa5ed571f0fb2c4a5641409b1a46b4961b",
      "name": null,
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 39,
      "daoAmount": 20,
      "proposalsAmount": 46,
      "votesAmount": 1463,
      "participationScore": "218.80",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x9ba6baa919bac9acd901df3bfde848fe006d3cae",
      "name": "sznews.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 40,
      "daoAmount": 78,
      "proposalsAmount": 0,
      "votesAmount": 1675,
      "participationScore": "218.44",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x972a8b7d891b88220780421fe4d11f174354ceed",
      "name": "kongdata.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 41,
      "daoAmount": 66,
      "proposalsAmount": 0,
      "votesAmount": 1658,
      "participationScore": "217.59",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x7a3bdee62dd34fac317ae61cd8b3ba7c27ada145",
      "name": "reblt.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 42,
      "daoAmount": 69,
      "proposalsAmount": 0,
      "votesAmount": 1659,
      "participationScore": "217.39",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0xbda0136ea391e24a938793972726f8763150c7c3",
      "name": "blockchian.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 43,
      "daoAmount": 81,
      "proposalsAmount": 0,
      "votesAmount": 1646,
      "participationScore": "217.06",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x52ea58f4fc3ced48fa18e909226c1f8a0ef887dc",
      "name": "stakedao-delegation.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 44,
      "daoAmount": 39,
      "proposalsAmount": 35,
      "votesAmount": 1628,
      "participationScore": "216.69",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x24749aedf18208ab74a8110e07e820286bb5acf8",
      "name": "dehyad.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 45,
      "daoAmount": 100,
      "proposalsAmount": 0,
      "votesAmount": 1843,
      "participationScore": "216.18",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x4d477f1aabcfc2fc3fc9b802e861c013e0123ad9",
      "name": "wzrdcat.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 46,
      "daoAmount": 137,
      "proposalsAmount": 8,
      "votesAmount": 1769,
      "participationScore": "213.14",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x09b17dbcd8ac17ed5d2d6bd22ecb8eb68759cb4b",
      "name": "angoozman.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 47,
      "daoAmount": 43,
      "proposalsAmount": 0,
      "votesAmount": 1498,
      "participationScore": "212.45",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x5ff817a31c03828c9f8995fc8b70b2eab5e59acc",
      "name": "liniyas.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 48,
      "daoAmount": 72,
      "proposalsAmount": 4,
      "votesAmount": 1639,
      "participationScore": "211.92",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x3fb19771947072629c8eee7995a2ef23b72d4c8a",
      "name": "pgov.eth",
      "avatar": null,
      "isSmartContract": null,
      "description": null,
      "aum": null,
      "rank": 49,
      "daoAmount": 30,
      "proposalsAmount": 61,
      "votesAmount": 1236,
      "participationScore": "209.16",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0xd6eff8f07caf3443a1178407d3de4129149d6ef6",
      "name": "canessadcl.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 50,
      "daoAmount": 4,
      "proposalsAmount": 0,
      "votesAmount": 1515,
      "participationScore": "207.97",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x768e4afbb8e8a8252aca1d35b6b2537e3df3caa4",
      "name": "krishanbansal.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 51,
      "daoAmount": 56,
      "proposalsAmount": 1,
      "votesAmount": 1421,
      "participationScore": "207.43",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x8787fc2de4de95c53e5e3a4e5459247d9773ea52",
      "name": "governance.kpk.eth",
      "avatar": null,
      "isSmartContract": null,
      "description": null,
      "aum": null,
      "rank": 52,
      "daoAmount": 15,
      "proposalsAmount": 24,
      "votesAmount": 1439,
      "participationScore": "207.37",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x8c57d1fab10d4b78f49ef5c6abaeb76a63710f61",
      "name": "vdovinda.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 53,
      "daoAmount": 89,
      "proposalsAmount": 0,
      "votesAmount": 1619,
      "participationScore": "206.70",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x1f8231ef50e99d361b5252a24ec2ec44285367e1",
      "name": "denispro2015.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 54,
      "daoAmount": 58,
      "proposalsAmount": 0,
      "votesAmount": 1438,
      "participationScore": "206.00",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0xb933aee47c438f22de0747d57fc239fe37878dd1",
      "name": "wintermutegovernance.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 55,
      "daoAmount": 18,
      "proposalsAmount": 14,
      "votesAmount": 1459,
      "participationScore": "205.72",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x00432772ed25d4eb3c6eb26dc461239b35cf8760",
      "name": "slmplex.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 56,
      "daoAmount": 66,
      "proposalsAmount": 0,
      "votesAmount": 1549,
      "participationScore": "205.27",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x247e0896706bb09245549e476257a0a1129db418",
      "name": "lordlike.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 57,
      "daoAmount": 4,
      "proposalsAmount": 6,
      "votesAmount": 1482,
      "participationScore": "204.44",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x1b9da462d07512fa37021973d853b59debb761dd",
      "name": "bitcloutcat.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 58,
      "daoAmount": 71,
      "proposalsAmount": 0,
      "votesAmount": 1550,
      "participationScore": "201.85",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x35e6fc00e3f190a8dfe15faa219368a01028ec14",
      "name": "indigituseth.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 59,
      "daoAmount": 61,
      "proposalsAmount": 0,
      "votesAmount": 1526,
      "participationScore": "201.55",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0xdc9c5e34959ec3643af1e1d34a83d6b251aab1ef",
      "name": "yuva.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 60,
      "daoAmount": 66,
      "proposalsAmount": 0,
      "votesAmount": 1670,
      "participationScore": "200.37",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x947b7742c403f20e5faccdac5e092c943e7d0277",
      "name": null,
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 61,
      "daoAmount": 4,
      "proposalsAmount": 6,
      "votesAmount": 1669,
      "participationScore": "198.64",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x0749d1abb5ca9128432b612644c0ea1e9c6cc9af",
      "name": "alphaangels.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 62,
      "daoAmount": 5,
      "proposalsAmount": 1,
      "votesAmount": 1441,
      "participationScore": "198.38",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0xac236ea8ed1c73a83b5a10d17988028fec528f59",
      "name": "neeer.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 63,
      "daoAmount": 43,
      "proposalsAmount": 0,
      "votesAmount": 1448,
      "participationScore": "197.72",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x4599acc33c2c8f47dcb9646d5120a874fcb6b1d6",
      "name": "pinkkittyjen.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 64,
      "daoAmount": 6,
      "proposalsAmount": 0,
      "votesAmount": 1409,
      "participationScore": "194.64",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0xcef28ce7884ae973990fb826c1986afaa9319b9a",
      "name": "tommy-shelby.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 65,
      "daoAmount": 51,
      "proposalsAmount": 0,
      "votesAmount": 1453,
      "participationScore": "194.08",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x168f87fbfe36b84e44b9d06278b2aa1cc73d7400",
      "name": "0xteaser.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 66,
      "daoAmount": 70,
      "proposalsAmount": 1,
      "votesAmount": 1425,
      "participationScore": "193.99",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x281ad9f2138ec59c3a9e7e4c98728c93eed868af",
      "name": "zolazzz.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 67,
      "daoAmount": 38,
      "proposalsAmount": 0,
      "votesAmount": 1519,
      "participationScore": "191.55",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0xbcdde113e0be48145d119f6ec87a78582cd1398c",
      "name": "70x40.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 68,
      "daoAmount": 45,
      "proposalsAmount": 0,
      "votesAmount": 1459,
      "participationScore": "191.02",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x7683c36e3067ad69e2ac06ddb21250eaf4e4ffed",
      "name": "ens92.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 69,
      "daoAmount": 26,
      "proposalsAmount": 0,
      "votesAmount": 1748,
      "participationScore": "190.42",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0xe0e216283eef00895b6abaa73848448596b85724",
      "name": "amankrisz.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 70,
      "daoAmount": 46,
      "proposalsAmount": 1,
      "votesAmount": 1400,
      "participationScore": "189.39",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x3b3d96d7ba6d981ed0861e54d6298947b495f68f",
      "name": "nft-ultra.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 71,
      "daoAmount": 42,
      "proposalsAmount": 0,
      "votesAmount": 1406,
      "participationScore": "189.02",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0xa0efd27acc781549d5b78e89e561aa0903932d56",
      "name": "spoken.bakerydao.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 72,
      "daoAmount": 37,
      "proposalsAmount": 0,
      "votesAmount": 1356,
      "participationScore": "188.79",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0xc56618e14dc795d0a3aef77cfc9f3b1dba2514c6",
      "name": "kiskisnotdead.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 73,
      "daoAmount": 44,
      "proposalsAmount": 2,
      "votesAmount": 1596,
      "participationScore": "187.68",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x0057be07beef5d9b4beb9e2d147906e83d1915c8",
      "name": "0xmojojojo.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 74,
      "daoAmount": 47,
      "proposalsAmount": 0,
      "votesAmount": 1398,
      "participationScore": "187.07",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x11a7dcf5beb6c04e6ae72c74870c6ca3f0d1afd9",
      "name": "aliab3d.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 75,
      "daoAmount": 57,
      "proposalsAmount": 0,
      "votesAmount": 1438,
      "participationScore": "186.20",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x338571a641d8c43f9e5a306300c5d89e0cb2cfaf",
      "name": "mazafaka.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 76,
      "daoAmount": 15,
      "proposalsAmount": 6,
      "votesAmount": 1409,
      "participationScore": "185.61",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x49087eb6f9529eb02a508fb820d7b4d0b52e4881",
      "name": "metamess.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 77,
      "daoAmount": 65,
      "proposalsAmount": 1,
      "votesAmount": 1490,
      "participationScore": "184.37",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x48b576c87e788a762d6f95a456f2a39113b46950",
      "name": "mydearmama.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 78,
      "daoAmount": 97,
      "proposalsAmount": 0,
      "votesAmount": 1631,
      "participationScore": "183.98",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x770bebe5946907cee4dfe004f1648ac435a9d5bb",
      "name": null,
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 79,
      "daoAmount": 59,
      "proposalsAmount": 0,
      "votesAmount": 1367,
      "participationScore": "182.48",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0xcc4f1cb6064a69ac83a5133ffcf09217ae33c2cf",
      "name": "0xoldboy.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 80,
      "daoAmount": 52,
      "proposalsAmount": 0,
      "votesAmount": 1353,
      "participationScore": "181.77",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x050b6ee782a6c25cbe3da0624a27b23067fa6251",
      "name": "jikaa.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 81,
      "daoAmount": 27,
      "proposalsAmount": 1,
      "votesAmount": 1405,
      "participationScore": "181.63",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0xab7b49bacd43bd4cfa41433d477f690bb9e1fb26",
      "name": "81899.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 82,
      "daoAmount": 125,
      "proposalsAmount": 1,
      "votesAmount": 1477,
      "participationScore": "180.77",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x119383b0051e920d6161cee971247d625b8d69cb",
      "name": null,
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 83,
      "daoAmount": 53,
      "proposalsAmount": 0,
      "votesAmount": 1356,
      "participationScore": "179.28",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x79ccedbefbfe6c95570d85e65f8b0ac0d6bd017b",
      "name": null,
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 84,
      "daoAmount": 51,
      "proposalsAmount": 0,
      "votesAmount": 1357,
      "participationScore": "179.12",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x71d021d5371d35df2cff9d132a562747ca6fa8a8",
      "name": "minatore.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 85,
      "daoAmount": 20,
      "proposalsAmount": 0,
      "votesAmount": 1224,
      "participationScore": "178.83",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x9f74662ad05840ba35d111930501c617920dd68e",
      "name": "veballer.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 86,
      "daoAmount": 6,
      "proposalsAmount": 390,
      "votesAmount": 746,
      "participationScore": "178.66",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x38daea6f17e4308b0da9647db9ca6d84a3a7e195",
      "name": "Alex Core",
      "avatar": "https://ipfs.io/ipfs/Qmc5rDcaNofq7Jw69EWVKWtoWMmhgJiQ611631vXAtuby2",
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 87,
      "daoAmount": 128,
      "proposalsAmount": 3,
      "votesAmount": 1512,
      "participationScore": "178.54",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x1e39cc29009ed4760c186d8771295c1e224882d4",
      "name": "madiba.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 88,
      "daoAmount": 57,
      "proposalsAmount": 0,
      "votesAmount": 1351,
      "participationScore": "177.79",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x5a2cf5b6061de4cd3c5936a781621fa8e4d1fdcf",
      "name": "gusha.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 89,
      "daoAmount": 60,
      "proposalsAmount": 0,
      "votesAmount": 1297,
      "participationScore": "177.47",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x618ee1b1276781cfc7180266aaa737ab8df48518",
      "name": "pigame.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 90,
      "daoAmount": 58,
      "proposalsAmount": 8,
      "votesAmount": 1311,
      "participationScore": "176.76",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0xe58585b22cc2ac4270a2b92c2d2d8c5db5a3330e",
      "name": "refri.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 91,
      "daoAmount": 42,
      "proposalsAmount": 2,
      "votesAmount": 1431,
      "participationScore": "176.74",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x7d55507f7d96b373706c0131fffbc4ffdcb3b6f6",
      "name": "casea.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 92,
      "daoAmount": 50,
      "proposalsAmount": 4,
      "votesAmount": 1318,
      "participationScore": "176.29",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x1a74d0285a569120aa2836cb2b0fa58038adb800",
      "name": "amir007.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 93,
      "daoAmount": 81,
      "proposalsAmount": 0,
      "votesAmount": 1428,
      "participationScore": "175.98",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x4aef8b6ca98ca20087e6b0827a50868172a32afd",
      "name": null,
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 94,
      "daoAmount": 48,
      "proposalsAmount": 0,
      "votesAmount": 1326,
      "participationScore": "175.26",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x896212da5d35dbf0e7c57a37133f0c97033f82b5",
      "name": "wtvua.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 95,
      "daoAmount": 49,
      "proposalsAmount": 0,
      "votesAmount": 1271,
      "participationScore": "175.25",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x13dda63c28bb95fe9822fea43ad5feaa966636a9",
      "name": "likerogue.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 96,
      "daoAmount": 85,
      "proposalsAmount": 2,
      "votesAmount": 1404,
      "participationScore": "175.22",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x4c710b38199f589dd769d36ed52b6d0170cb83ee",
      "name": "darknighte5a.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 97,
      "daoAmount": 88,
      "proposalsAmount": 1,
      "votesAmount": 1394,
      "participationScore": "174.98",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x1c85d6ae1336d0e4e3f165bbfa9641bfa04cedb1",
      "name": "LOTR",
      "avatar": "https://ipfs.io/ipfs/Qmb6vg95QnwmPhNUq8QfYQAPTf3rKcj1Gb8iBt8vYNzwo6",
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 98,
      "daoAmount": 90,
      "proposalsAmount": 0,
      "votesAmount": 1483,
      "participationScore": "173.62",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0xeab804590011d0650fcb6c4da1870c6e9ca062d1",
      "name": "croth.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 99,
      "daoAmount": 66,
      "proposalsAmount": 4,
      "votesAmount": 1403,
      "participationScore": "173.23",
      "participationRelativeScore": 99.99
  },
  {
      "address": "0x8bc8b4e4921101bcc56ec084b906069b73de7276",
      "name": "yuiyui.eth",
      "avatar": null,
      "isSmartContract": false,
      "description": null,
      "aum": null,
      "rank": 100,
      "daoAmount": 68,
      "proposalsAmount": 1,
      "votesAmount": 1387,
      "participationScore": "172.66",
      "participationRelativeScore": 99.99
  }
];

export const peopleStatsMocked = {
  "id": "59f697be-7d6b-408b-992b-11b85caa566b",
  "createdAt": "2022-03-14T14:48:16.670Z",
  "totalUsdAum": "5550271",
  "aumWeekChange": "-1810971",
  "aumMonthChange": "-1810971",
  "historyUsdAum": [
      {
          "date": "2021-04-05",
          "aum": 421083064.53
      },
      {
          "date": "2021-04-20",
          "aum": 392401482.35
      },
      {
          "date": "2021-04-24",
          "aum": 375001925.57
      },
      {
          "date": "2021-05-06",
          "aum": 519965667.09
      },
      {
          "date": "2021-05-07",
          "aum": 563398379.4
      },
      {
          "date": "2021-05-07",
          "aum": 559985343.73
      },
      {
          "date": "2021-05-11",
          "aum": 617931582.69
      },
      {
          "date": "2021-05-11",
          "aum": 610711683.75
      },
      {
          "date": "2021-05-11",
          "aum": 615209626.33
      },
      {
          "date": "2021-05-12",
          "aum": 657368417.38
      },
      {
          "date": "2021-05-12",
          "aum": 659426502.07
      },
      {
          "date": "2021-05-13",
          "aum": 613214637.83
      },
      {
          "date": "2021-05-13",
          "aum": 604078381.93
      },
      {
          "date": "2021-05-14",
          "aum": 626692427.79
      },
      {
          "date": "2021-05-14",
          "aum": 647227694.78
      },
      {
          "date": "2021-05-17",
          "aum": 517030761.73
      },
      {
          "date": "2021-05-19",
          "aum": 493555844.6
      },
      {
          "date": "2021-05-19",
          "aum": 481800377.38
      },
      {
          "date": "2021-05-20",
          "aum": 447720169.23
      },
      {
          "date": "2021-05-20",
          "aum": 447244757.46
      },
      {
          "date": "2021-05-21",
          "aum": 444857813.19
      },
      {
          "date": "2021-05-21",
          "aum": 415616923.28
      },
      {
          "date": "2021-05-26",
          "aum": 450278742.62
      },
      {
          "date": "2021-05-28",
          "aum": 406019581.98
      },
      {
          "date": "2021-05-31",
          "aum": 400005542.26
      },
      {
          "date": "2021-06-02",
          "aum": 435242573.25
      },
      {
          "date": "2021-06-03",
          "aum": 464354624.48
      },
      {
          "date": "2021-06-08",
          "aum": 392908301.81
      },
      {
          "date": "2021-06-09",
          "aum": 395387112.82
      },
      {
          "date": "2021-06-17",
          "aum": 396728649.82
      },
      {
          "date": "2021-07-01",
          "aum": 366889649.03
      },
      {
          "date": "2021-07-02",
          "aum": 353641201.87
      },
      {
          "date": "2021-07-05",
          "aum": 405900931.21
      },
      {
          "date": "2021-07-06",
          "aum": 413116136.98
      },
      {
          "date": "2021-07-14",
          "aum": 360078985.91
      },
      {
          "date": "2021-07-15",
          "aum": 359398254.9
      },
      {
          "date": "2021-07-16",
          "aum": 346581856.19
      },
      {
          "date": "2021-07-19",
          "aum": 343374728.45
      },
      {
          "date": "2021-07-20",
          "aum": 339016990.64
      },
      {
          "date": "2021-07-22",
          "aum": 389892898.52
      },
      {
          "date": "2021-07-23",
          "aum": 404817514.21
      },
      {
          "date": "2021-07-26",
          "aum": 434068983.18
      },
      {
          "date": "2021-07-28",
          "aum": 435659409.58
      },
      {
          "date": "2021-07-30",
          "aum": 458815226.11
      },
      {
          "date": "2021-08-02",
          "aum": 500302227.99
      },
      {
          "date": "2021-08-03",
          "aum": 472054027.4
      },
      {
          "date": "2021-08-04",
          "aum": 476797306.22
      },
      {
          "date": "2021-08-05",
          "aum": 496003615.97
      },
      {
          "date": "2021-08-06",
          "aum": 532751711.54
      },
      {
          "date": "2021-08-09",
          "aum": 535031884.49
      },
      {
          "date": "2021-08-10",
          "aum": 567965255.67
      },
      {
          "date": "2021-08-11",
          "aum": 576058372.16
      },
      {
          "date": "2021-08-12",
          "aum": 572237557.79
      },
      {
          "date": "2021-08-13",
          "aum": 580894125
      },
      {
          "date": "2021-08-16",
          "aum": 585222294.61
      },
      {
          "date": "2021-08-17",
          "aum": 577780080.44
      },
      {
          "date": "2021-08-18",
          "aum": 553365777.57
      },
      {
          "date": "2021-08-19",
          "aum": 546685895.09
      },
      {
          "date": "2021-08-20",
          "aum": 591306490.08
      },
      {
          "date": "2021-08-20",
          "aum": 593575302.5
      },
      {
          "date": "2021-12-24",
          "aum": 255637202.67
      },
      {
          "date": "2021-12-26",
          "aum": 255637202.67
      },
      {
          "date": "2021-12-26",
          "aum": 255637202.67
      },
      {
          "date": "2021-12-31",
          "aum": 2085510.04
      },
      {
          "date": "2021-12-31",
          "aum": 140087154.99
      },
      {
          "date": "2021-12-31",
          "aum": 0
      },
      {
          "date": "2021-12-31",
          "aum": 0
      },
      {
          "date": "2021-12-31",
          "aum": 0
      },
      {
          "date": "2021-12-31",
          "aum": 0
      },
      {
          "date": "2021-12-31",
          "aum": 0
      },
      {
          "date": "2021-12-31",
          "aum": 0
      },
      {
          "date": "2021-12-31",
          "aum": 0
      },
      {
          "date": "2021-12-31",
          "aum": 0
      },
      {
          "date": "2021-12-31",
          "aum": 0
      },
      {
          "date": "2021-12-31",
          "aum": 0
      },
      {
          "date": "2021-12-31",
          "aum": 0
      },
      {
          "date": "2022-01-09",
          "aum": 39677391.44
      },
      {
          "date": "2022-01-10",
          "aum": 55438453.6
      },
      {
          "date": "2022-01-11",
          "aum": 2540433.06
      },
      {
          "date": "2022-01-11",
          "aum": 5055303.86
      },
      {
          "date": "2022-01-11",
          "aum": 7592753.83
      },
      {
          "date": "2022-01-11",
          "aum": 10122584.99
      },
      {
          "date": "2022-01-12",
          "aum": 3166207.38
      },
      {
          "date": "2022-01-12",
          "aum": 16346287.61
      },
      {
          "date": "2022-01-18",
          "aum": 3037324.47
      },
      {
          "date": "2022-03-10",
          "aum": 7361241.93
      },
      {
          "date": "2022-03-14",
          "aum": 12350855.13
      },
      {
          "date": "2022-03-14",
          "aum": 5550270.9
      }
  ],
  "aumGraph": [
      {
          "name": "aum0To25k",
          "value": 87
      },
      {
          "name": "aum25kTo50k",
          "value": 5
      },
      {
          "name": "aum50kTo100k",
          "value": 7
      },
      {
          "name": "aum100kTo200k",
          "value": 10
      },
      {
          "name": "aum200kTo1m",
          "value": 9
      },
      {
          "name": "aum1m",
          "value": 0
      }
  ],
  "aumByPopulation": [
      {
          "name": "1st",
          "value": 3552775.82
      },
      {
          "name": "2nd",
          "value": 1313966.04
      },
      {
          "name": "3rd",
          "value": 410705.03
      },
      {
          "name": "4th",
          "value": 174215.32
      },
      {
          "name": "5th",
          "value": 58123.32
      },
      {
          "name": "6th",
          "value": 25290.79
      },
      {
          "name": "7th",
          "value": 8652.66
      },
      {
          "name": "8th",
          "value": 4621.41
      },
      {
          "name": "9th",
          "value": 1711.15
      },
      {
          "name": "10th",
          "value": 209.38
      }
  ],
  "aumTokens": [
      {
          "tokenAddress": "eth",
          "symbol": "ETH",
          "name": "Ethereum",
          "usd": 900240.5599999999,
          "logo": "https://token-icons.s3.amazonaws.com/eth.png",
          "rank": 1,
          "totalHolders": 117
      },
      {
          "tokenAddress": "0x6b175474e89094c44da98b954eedeac495271d0f",
          "symbol": "DAI",
          "name": "Dai",
          "usd": 342350.47,
          "logo": "https://s3.amazonaws.com/token-icons/0x6b175474e89094c44da98b954eedeac495271d0f.png",
          "rank": 2,
          "totalHolders": 53
      },
      {
          "tokenAddress": "0xfd3300a9a74b3250f1b2abc12b47611171910b07",
          "symbol": "fTRIBE-8",
          "name": "Tetranode's Flavor of the Month Tribe",
          "usd": 256199.56,
          "logo": "https://token-icons.s3.amazonaws.com/0xd291e7a03283640fdc51b121ac401383a46cc623.png",
          "rank": 3,
          "totalHolders": 4
      },
      {
          "tokenAddress": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
          "symbol": "USDC",
          "name": "USD Coin",
          "usd": 246814.54000000004,
          "logo": "https://token-icons.s3.amazonaws.com/0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48.png",
          "rank": 4,
          "totalHolders": 47
      },
      {
          "tokenAddress": "0xfb5453340c03db5ade474b27e68b6a9c6b2823eb",
          "symbol": "ROBOT",
          "name": "MetaFactory",
          "usd": 142091.58999999997,
          "logo": "https://token-icons.s3.amazonaws.com/0xfb5453340c03db5ade474b27e68b6a9c6b2823eb.png",
          "rank": 5,
          "totalHolders": 13
      },
      {
          "tokenAddress": "0xc18360217d8f7ab5e7c516566761ea12ce7f9d72",
          "symbol": "ENS",
          "name": "Ethereum Name Service",
          "usd": 124479.86999999998,
          "logo": "https://token-icons.s3.amazonaws.com/0xc18360217d8f7ab5e7c516566761ea12ce7f9d72.png",
          "rank": 6,
          "totalHolders": 71
      },
      {
          "tokenAddress": "0x5a98fcbea516cf06857215779fd812ca3bef1b32",
          "symbol": "LDO",
          "name": "Lido DAO Token",
          "usd": 112019.78,
          "logo": "https://token-icons.s3.amazonaws.com/0x5a98fcbea516cf06857215779fd812ca3bef1b32.png",
          "rank": 7,
          "totalHolders": 7
      },
      {
          "tokenAddress": "0xf2051511b9b121394fa75b8f7d4e7424337af687",
          "symbol": "HAUS",
          "name": "DAOhaus Token",
          "usd": 85468.89999999998,
          "logo": null,
          "rank": 8,
          "totalHolders": 7
      },
      {
          "tokenAddress": "0xccf5575570fac94cec733a58ff91bb3d073085c7",
          "symbol": "iROBOT",
          "name": "MetaFactory Pool Token",
          "usd": 74618.68000000001,
          "logo": null,
          "rank": 9,
          "totalHolders": 3
      },
      {
          "tokenAddress": "0x23b608675a2b2fb1890d3abbd85c5775c51691d5",
          "symbol": "SOCKS",
          "name": "Unisocks Edition 0",
          "usd": 72916.87999999999,
          "logo": "https://token-icons.s3.amazonaws.com/0x23b608675a2b2fb1890d3abbd85c5775c51691d5.png",
          "rank": 10,
          "totalHolders": 9
      },
      {
          "tokenAddress": "0xde30da39c46104798bb5aa3fe8b9e0e1f348163f",
          "symbol": "GTC",
          "name": "Gitcoin",
          "usd": 66624.56,
          "logo": "https://token-icons.s3.amazonaws.com/0xde30da39c46104798bb5aa3fe8b9e0e1f348163f.png",
          "rank": 11,
          "totalHolders": 67
      },
      {
          "tokenAddress": "0x0bc529c00c6401aef6d220be8c6ea1667f6ad93e",
          "symbol": "YFI",
          "name": "yearn.finance",
          "usd": 58197.88,
          "logo": "https://token-icons.s3.amazonaws.com/0x0bc529c00c6401aef6d220be8c6ea1667f6ad93e.png",
          "rank": 12,
          "totalHolders": 37
      },
      {
          "tokenAddress": "0x0954906da0bf32d5479e25f46056d22f08464cab",
          "symbol": "INDEX",
          "name": "Index",
          "usd": 48508.67,
          "logo": "https://token-icons.s3.amazonaws.com/0x0954906da0Bf32d5479e25f46056d22f08464cab.png",
          "rank": 13,
          "totalHolders": 15
      },
      {
          "tokenAddress": "0x1f9840a85d5af5bf1d1762f925bdaddc4201f984",
          "symbol": "UNI",
          "name": "Uniswap",
          "usd": 46758.81999999999,
          "logo": "https://token-icons.s3.amazonaws.com/0x1f9840a85d5af5bf1d1762f925bdaddc4201f984.png",
          "rank": 14,
          "totalHolders": 59
      },
      {
          "tokenAddress": "0x2d94aa3e47d9d5024503ca8491fce9a2fb4da198",
          "symbol": "BANK",
          "name": "Bankless Token",
          "usd": 35727.68999999999,
          "logo": "https://token-icons.s3.amazonaws.com/0x2d94aa3e47d9d5024503ca8491fce9a2fb4da198.png",
          "rank": 15,
          "totalHolders": 31
      },
      {
          "tokenAddress": "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
          "symbol": "WETH",
          "name": "Wrapped Ether",
          "usd": 35501.979999999996,
          "logo": "https://s3.amazonaws.com/token-icons/0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2.png",
          "rank": 16,
          "totalHolders": 28
      },
      {
          "tokenAddress": "0x50d1c9771902476076ecfc8b2a83ad6b9355a4c9",
          "symbol": "FTT",
          "name": "FTT",
          "usd": 31719.14,
          "logo": "https://token-icons.s3.amazonaws.com/0x50d1c9771902476076ecfc8b2a83ad6b9355a4c9.png",
          "rank": 17,
          "totalHolders": 2
      },
      {
          "tokenAddress": "0x4da27a545c0c5b758a6ba100e3a049001de870f5",
          "symbol": "stkAAVE",
          "name": "Staked Aave",
          "usd": 28572.530000000002,
          "logo": "https://token-icons.s3.amazonaws.com/0x4da27a545c0c5b758a6ba100e3a049001de870f5.png",
          "rank": 18,
          "totalHolders": 11
      },
      {
          "tokenAddress": "0xac67448cc410e706a5652585f48af8d3b02eef73",
          "symbol": "BPT-V1",
          "name": "Balancer 30% WETH + 70% HAUS Pool",
          "usd": 27430.34,
          "logo": null,
          "rank": 19,
          "totalHolders": 1
      },
      {
          "tokenAddress": "0x35bd01fc9d6d5d81ca9e055db88dc49aa2c699a8",
          "symbol": "FWB",
          "name": "Friends With Benefits Pro",
          "usd": 26330.28,
          "logo": "https://token-icons.s3.amazonaws.com/0x35bd01fc9d6d5d81ca9e055db88dc49aa2c699a8.png",
          "rank": 20,
          "totalHolders": 11
      },
      {
          "tokenAddress": "0x7e7e112a68d8d2e221e11047a72ffc1065c38e1a",
          "symbol": "bDIGG",
          "name": "Badger Sett Digg",
          "usd": 23821.24,
          "logo": "https://token-icons.s3.amazonaws.com/0x7e7e112a68d8d2e221e11047a72ffc1065c38e1a.png",
          "rank": 21,
          "totalHolders": 19
      },
      {
          "tokenAddress": "0x618679df9efcd19694bb1daa8d00718eacfa2883",
          "symbol": "XYZ",
          "name": "XYZ Governance Token",
          "usd": 21900.04,
          "logo": "https://token-icons.s3.amazonaws.com/0x618679df9efcd19694bb1daa8d00718eacfa2883.png",
          "rank": 22,
          "totalHolders": 3
      },
      {
          "tokenAddress": "0x8798249c2e607446efb7ad49ec89dd1865ff4272",
          "symbol": "xSUSHI",
          "name": "SushiBar",
          "usd": 21760.840000000004,
          "logo": "https://token-icons.s3.amazonaws.com/0x8798249c2e607446efb7ad49ec89dd1865ff4272.png",
          "rank": 23,
          "totalHolders": 36
      },
      {
          "tokenAddress": "0xdac17f958d2ee523a2206206994597c13d831ec7",
          "symbol": "USDT",
          "name": "Tether USD",
          "usd": 21035.86,
          "logo": "https://token-icons.s3.amazonaws.com/0xdac17f958d2ee523a2206206994597c13d831ec7.png",
          "rank": 24,
          "totalHolders": 21
      },
      {
          "tokenAddress": "0xa1d65e8fb6e87b60feccbc582f7f97804b725521",
          "symbol": "DXD",
          "name": "DXdao",
          "usd": 20209.32,
          "logo": "https://token-icons.s3.amazonaws.com/0xa1d65e8fb6e87b60feccbc582f7f97804b725521.png",
          "rank": 25,
          "totalHolders": 2
      },
      {
          "tokenAddress": "0x6def55d2e18486b9ddfaa075bc4e4ee0b28c1545",
          "symbol": "brenCrv",
          "name": "Badger Curve renBTC Sett",
          "usd": 20169.66,
          "logo": null,
          "rank": 26,
          "totalHolders": 1
      },
      {
          "tokenAddress": "0x31c8eacbffdd875c74b94b077895bd78cf1e64a3",
          "symbol": "RAD",
          "name": "Radicle",
          "usd": 20135.55,
          "logo": "https://token-icons.s3.amazonaws.com/0x31c8eacbffdd875c74b94b077895bd78cf1e64a3.png",
          "rank": 27,
          "totalHolders": 6
      },
      {
          "tokenAddress": "0x6de037ef9ad2725eb40118bb1702ebb27e4aeb24",
          "symbol": "RNDR",
          "name": "Render Token",
          "usd": 18759.49,
          "logo": "https://token-icons.s3.amazonaws.com/0x6de037ef9ad2725eb40118bb1702ebb27e4aeb24.png",
          "rank": 28,
          "totalHolders": 4
      },
      {
          "tokenAddress": "0xdb25ca703181e7484a155dd612b06f57e12be5f0",
          "symbol": "yvYFI",
          "name": "YFI yVault",
          "usd": 18561.64,
          "logo": null,
          "rank": 29,
          "totalHolders": 3
      },
      {
          "tokenAddress": "0x6123b0049f904d730db3c36a31167d9d4121fa6b",
          "symbol": "RBN",
          "name": "Ribbon",
          "usd": 18492.13,
          "logo": "https://token-icons.s3.amazonaws.com/0x6123b0049f904d730db3c36a31167d9d4121fa6b.png",
          "rank": 30,
          "totalHolders": 9
      },
      {
          "tokenAddress": "0xd81b1a8b1ad00baa2d6609e0bae28a38713872f7",
          "symbol": "PcUSDC",
          "name": "PoolTogether USDC Ticket (Compound)",
          "usd": 18464.239999999998,
          "logo": "https://token-icons.s3.amazonaws.com/0x0cec1a9154ff802e7934fc916ed7ca50bde6844e.png",
          "rank": 31,
          "totalHolders": 3
      },
      {
          "tokenAddress": "0xe80c0cd204d654cebe8dd64a4857cab6be8345a3",
          "symbol": "JPEG",
          "name": "JPEG’d Governance Token",
          "usd": 16596.45,
          "logo": null,
          "rank": 32,
          "totalHolders": 4
      },
      {
          "tokenAddress": "0x3abf2a4f8452ccc2cf7b4c1e4663147600646f66",
          "symbol": "JBX",
          "name": "Juicebox",
          "usd": 16360.109999999997,
          "logo": null,
          "rank": 33,
          "totalHolders": 12
      },
      {
          "tokenAddress": "0x0f5d2fb29fb7d3cfee444a200298f468908cc942",
          "symbol": "MANA",
          "name": "Decentraland MANA",
          "usd": 15729.150000000001,
          "logo": "https://s3.amazonaws.com/token-icons/0x0f5d2fb29fb7d3cfee444a200298f468908cc942.png",
          "rank": 34,
          "totalHolders": 12
      },
      {
          "tokenAddress": "0x27c9f71cc31464b906e0006d4fcbc8900f48f15f",
          "symbol": "80D2D-20USDC",
          "name": "80D2D-20USDC",
          "usd": 15637.12,
          "logo": null,
          "rank": 35,
          "totalHolders": 1
      },
      {
          "tokenAddress": "0x7e9d8f07a64e363e97a648904a89fb4cd5fb94cd",
          "symbol": "FF",
          "name": "Forefront",
          "usd": 15248.48,
          "logo": "https://token-icons.s3.amazonaws.com/0x7e9d8f07a64e363e97a648904a89fb4cd5fb94cd.png",
          "rank": 36,
          "totalHolders": 10
      },
      {
          "tokenAddress": "0xb44a59d72cb84a2f29cd1836734208e1860798fd",
          "symbol": "CULTUR",
          "name": "The Culture DAO",
          "usd": 13542.92,
          "logo": null,
          "rank": 37,
          "totalHolders": 1
      },
      {
          "tokenAddress": "0x7a58c0be72be218b41c608b7fe7c5bb630736c71",
          "symbol": "PEOPLE",
          "name": "ConstitutionDAO",
          "usd": 13475.069999999998,
          "logo": null,
          "rank": 38,
          "totalHolders": 16
      },
      {
          "tokenAddress": "0xfca59cd816ab1ead66534d82bc21e7515ce441cf",
          "symbol": "RARI",
          "name": "Rarible",
          "usd": 13082.819999999996,
          "logo": "https://token-icons.s3.amazonaws.com/0xfca59cd816ab1ead66534d82bc21e7515ce441cf.png",
          "rank": 39,
          "totalHolders": 27
      },
      {
          "tokenAddress": "0x30cf203b48edaa42c3b4918e955fed26cd012a3f",
          "symbol": "SEED",
          "name": "Seed",
          "usd": 12902.9,
          "logo": "https://token-icons.s3.amazonaws.com/0x30cf203b48edaa42c3b4918e955fed26cd012a3f.png",
          "rank": 40,
          "totalHolders": 6
      },
      {
          "tokenAddress": "0xc7283b66eb1eb5fb86327f08e1b5816b0720212b",
          "symbol": "TRIBE",
          "name": "Tribe",
          "usd": 12668.039999999999,
          "logo": "https://token-icons.s3.amazonaws.com/0xc7283b66eb1eb5fb86327f08e1b5816b0720212b.png",
          "rank": 41,
          "totalHolders": 11
      },
      {
          "tokenAddress": "0xeb4c2781e4eba804ce9a9803c67d0893436bb27d",
          "symbol": "renBTC",
          "name": "renBTC",
          "usd": 12638.61,
          "logo": "https://token-icons.s3.amazonaws.com/0xeb4c2781e4eba804ce9a9803c67d0893436bb27d.png",
          "rank": 42,
          "totalHolders": 4
      },
      {
          "tokenAddress": "0xba5bde662c17e2adff1075610382b9b691296350",
          "symbol": "RARE",
          "name": "SuperRare",
          "usd": 11870.02,
          "logo": "https://token-icons.s3.amazonaws.com/0xba5bde662c17e2adff1075610382b9b691296350.png",
          "rank": 43,
          "totalHolders": 8
      },
      {
          "tokenAddress": "0x7fc66500c84a76ad7e9c93437bfc5ac33e2ddae9",
          "symbol": "AAVE",
          "name": "Aave Token",
          "usd": 11545.909999999998,
          "logo": "https://token-icons.s3.amazonaws.com/0x7fc66500c84a76ad7e9c93437bfc5ac33e2ddae9.png",
          "rank": 44,
          "totalHolders": 39
      },
      {
          "tokenAddress": "0x4214290310264a27b0ba8cff02b4c592d0234aa1",
          "symbol": "UNI-V2",
          "name": "Uniswap RFOX/ETH Pool",
          "usd": 11130.63,
          "logo": "https://token-icons.s3.us-east-1.amazonaws.com/uniswap-v2.png",
          "rank": 45,
          "totalHolders": 1
      },
      {
          "tokenAddress": "0x92d6c1e31e14520e676a687f0a93788b716beff5",
          "symbol": "DYDX",
          "name": "dYdX",
          "usd": 10950.73,
          "logo": "https://token-icons.s3.amazonaws.com/0x92d6c1e31e14520e676a687f0a93788b716beff5.png",
          "rank": 46,
          "totalHolders": 16
      },
      {
          "tokenAddress": "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
          "symbol": "WBTC",
          "name": "Wrapped BTC",
          "usd": 10785.490000000002,
          "logo": "https://token-icons.s3.amazonaws.com/0x2260fac5e5542a773aa44fbcfedf7c193bc2c599.png",
          "rank": 47,
          "totalHolders": 9
      },
      {
          "tokenAddress": "0x3472a5a71965499acd81997a54bba8d852c6e53d",
          "symbol": "BADGER",
          "name": "Badger",
          "usd": 10745.76,
          "logo": "https://token-icons.s3.amazonaws.com/0x3472a5a71965499acd81997a54bba8d852c6e53d.png",
          "rank": 48,
          "totalHolders": 47
      },
      {
          "tokenAddress": "0xa1d6df714f91debf4e0802a542e13067f31b8262",
          "symbol": "RFOX",
          "name": "RFOX",
          "usd": 10449.26,
          "logo": "https://token-icons.s3.amazonaws.com/0xa1d6df714f91debf4e0802a542e13067f31b8262.png",
          "rank": 49,
          "totalHolders": 4
      },
      {
          "tokenAddress": "0x967da4048cd07ab37855c090aaf366e4ce1b9f48",
          "symbol": "OCEAN",
          "name": "Ocean Token",
          "usd": 9924.34,
          "logo": "https://token-icons.s3.amazonaws.com/0x7afebbb46fdb47ed17b22ed075cde2447694fb9e.png",
          "rank": 50,
          "totalHolders": 2
      }
  ]
}